import React, { useContext } from 'react';
import { MainHeader, Navigation } from '../components';
import { NavigationContext } from '../contexts';

export const MainLayout = (props) => {
  const { children } = props;
  const { navCollapsed = false } = useContext(NavigationContext);

  return (
    <div className={`main-layout ${navCollapsed ? 'navigation--collapsed' : ''}`}>
      <section className='navigation__container'>
        <Navigation></Navigation>
      </section>
      <section className='content__container'>
        <section className='header__box'>
          <MainHeader></MainHeader>
        </section>
        <section className='content__box'>
          <article className='scroll__container'>{children}</article>
        </section>
      </section>
    </div>
  );
};
